import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/pebble-logo.png';

const FooterPageLayout = ({ children }) => {
  return (
    <>
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link 
              to="/" 
              className="text-[#4A5568] hover:text-[#B22A2B] transition-colors font-medium"
            >
              ← Back to Pebble
            </Link>
            <nav className="flex space-x-4">
              <Link 
                to="/login" 
                className="text-[#4A5568] hover:text-[#B22A2B] px-3 py-2 rounded-md text-sm font-medium transition-colors"
              >
                Log In
              </Link>
              <Link 
                to="/create-account" 
                className="bg-[#B22A2B] text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-[#8a2122] transition-colors"
              >
                Sign Up
              </Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="flex-grow">
        {children}
      </main>

      <footer className="bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex justify-between items-center">
            <Link 
              to="/" 
              className="text-[#4A5568] hover:text-[#B22A2B] transition-colors font-medium"
            >
              ← Back to Pebble
            </Link>
<img src={logo} alt="Pebble" className="h-8 w-auto" />
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterPageLayout; 